import {Dropdown, Tooltip} from 'antd';
import styles from './exchanges.module.scss';

const COUNT_HELP =
  'Live counts enabled instruments only — that is what getExchanges reports and what mobile can surface. The total counts every status, including pending and disabled.';

const formatCount = (live, total) => {
  if (live == null && total == null) return null;
  if (total == null) return `${live.toLocaleString()} live`;
  if (live == null) return `${total.toLocaleString()} total`;
  return `${live.toLocaleString()} live · ${total.toLocaleString()} total`;
};

/**
 * The exchange lens, shared by Multi Asset and Trading View.
 *
 * A selector rather than a route hierarchy so All markets is always one click
 * away — an ops person must never have to visit three venues to see the whole
 * book. Both counts are shown because they disagree substantially: bonds are
 * 14 live against 185 total, and a single number would be read as the truth.
 */
export const ExchangeScopeSelector = ({
  exchangeId,
  setScope,
  exchanges,
  aggregate,
  totals,
  loading,
}) => {
  const items = [
    {
      key: 'all',
      label: (
        <div className={styles.scopeOption}>
          <span className={styles.scopeName}>All markets</span>
          <span className={styles.scopeCount}>
            {formatCount(aggregate?.instrumentCount, totals?.all)}
          </span>
        </div>
      ),
      onClick: () => setScope(null),
    },
    {type: 'divider', key: 'divider'},
    ...exchanges.map(node => ({
      key: node.exchange.id,
      label: (
        <div className={styles.scopeOption}>
          <span className={styles.scopeName}>
            {node.exchange.code}
            <span className={styles.scopeVenue}>
              {node.exchange.stockExchangeName}
            </span>
          </span>
          <span className={styles.scopeCount}>
            {formatCount(node.instrumentCount, totals?.[node.exchange.id])}
          </span>
        </div>
      ),
      onClick: () => setScope(node.exchange.id),
    })),
  ];

  const active = exchanges.find(node => node.exchange.id === exchangeId);
  const live = active ? active.instrumentCount : aggregate?.instrumentCount;
  const total = totals ? (active ? totals[exchangeId] : totals.all) : null;

  return (
    <div className={styles.scopeBar}>
      <Dropdown trigger={['click']} menu={{items}} disabled={loading}>
        <button type="button" className={styles.scopeTrigger}>
          <span className={styles.scopeLabel}>
            {active ? active.exchange.code : 'All markets'}
          </span>
          <span className={styles.scopeChevron}>▾</span>
        </button>
      </Dropdown>

      <Tooltip title={COUNT_HELP}>
        <span className={styles.scopeSummary}>
          {loading ? 'Loading exchanges…' : formatCount(live, total)}
        </span>
      </Tooltip>

      {/* Every exchange stays visible and one click away, which is the point of a
          lens over a hierarchy. */}
      <div className={styles.scopeVenues}>
        {exchanges.map(node => (
          <button
            type="button"
            key={node.exchange.id}
            onClick={() =>
              setScope(
                node.exchange.id === exchangeId ? null : node.exchange.id,
              )
            }
            className={`${styles.venueChip} ${
              node.exchange.id === exchangeId ? styles.venueChipOn : ''
            }`}>
            {node.exchange.code}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExchangeScopeSelector;
